export default "__VITE_ASSET__CGoXL96J__"